// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"2ead424e","89":"1560897e","144":"f4099e58","360":"9a206811","380":"73a5cbbc","653":"ea861d2f","845":"cb878fc4","863":"1560897e","897":"b119a0cf"}[chunkId] + ".chunk.css";
};